export default "__VITE_ASSET__wTnTxtUP__"